<div class="order-item p-6 mb-6 bg-white border border-gray-200 rounded-2xl transition-all duration-300">
  <!-- Order Info -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
    <!-- Order ID -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faHashtag"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Order ID</span
        >
        <span class="text-sm font-semibold text-gray-900">
          {{ order?.id || "–" }}
        </span>
      </div>
    </div>

    <!-- Date -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faCalendarAlt"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide">Date</span>
        <span class="text-sm font-semibold text-gray-900">
          {{ order?.createdAt ? (order.createdAt | date: "mediumDate") : "–" }}
        </span>
      </div>
    </div>

    <!-- Total -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faRupeeSign"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Sub Total</span
        >
        <span class="text-sm font-semibold text-gray-900">
          Rs.
          {{
            order?.subTotal != null ? (order.subTotal | number: "1.2-2") : "–"
          }}
        </span>
      </div>
    </div>

    <!-- Total -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faRupeeSign"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Shipping</span
        >
        <span class="text-sm font-semibold text-gray-900">
          Rs.
          {{
            order?.shippingFee != null
              ? (order.shippingFee | number: "1.2-2")
              : "–"
          }}
        </span>
      </div>
    </div>

    <!-- Total -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faRupeeSign"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Discount</span
        >
        <span class="text-sm text-green-600 font-semibold text-gray-900">
          Rs.
          {{
            order?.discount != null ? (order.discount | number: "1.2-2") : "–"
          }}
        </span>
      </div>
    </div>

    <!-- Total -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faRupeeSign"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide">Total</span>
        <span class="text-sm text-red-600 font-semibold text-gray-900">
          Rs. {{ order?.total != null ? (order.total | number: "1.2-2") : "–" }}
        </span>
      </div>
    </div>

    <!-- Status -->
    <div class="flex items-start gap-3">
      <fa-icon
        [icon]="faInfoCircle"
        class="text-[var(--primary)] mt-0.5"
      ></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Status</span
        >
        <span
          class="text-sm font-semibold capitalize"
          [ngClass]="{
            'text-green-600': order?.status === 'delivered',
            'text-blue-600': order?.status === 'shipped',
            'text-yellow-600': order?.status === 'packing',
            'text-red-600': order?.status === 'cancelled',
            'text-gray-900': !order?.status,
          }"
        >
          {{ order?.status || "–" }}
        </span>
      </div>
    </div>

    <!-- Tracking Number -->
    <div class="flex items-start gap-3 sm:col-span-2">
      <fa-icon [icon]="faTruck" class="text-[var(--primary)] mt-0.5"></fa-icon>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500 uppercase tracking-wide"
          >Tracking Number</span
        >
        <span class="text-sm font-semibold text-gray-900">
          {{ order?.trackingNumber || "–" }}
        </span>
      </div>
    </div>
  </div>

  <!-- Products Section -->
  <div class="flex gap-4 overflow-x-auto pb-4 border-b border-gray-200">
    <ng-container *ngFor="let product of order.products">
      <div
        class="relative min-w-[140px] max-w-[140px] flex flex-col items-center bg-white rounded-lg border border-gray-300 p-3 cursor-pointer transition hover:border-[var(--primary)]"
      >
        <img
          [src]="product.images?.[0] || '/placeholder.svg'"
          (error)="onImageError($event)"
          [alt]="product.product.name"
          class="w-24 h-24 aspect-square object-cover rounded-xl mb-2"
        />

        <!-- Product Name -->
        <span
          class="text-sm font-semibold text-gray-900 text-center leading-tight line-clamp-2"
          [title]="product.product.name"
        >
          {{ product.product.name }}
        </span>

        <!-- Quantity badge -->
        <span
          class="absolute top-2 right-2 bg-[var(--primary)] text-white text-xs font-bold rounded-full px-2 py-0.5 select-none"
        >
          {{ product.quantity }}
        </span>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="order.status === 'Pending'"
    class="border mt-4 border-gray-300 rounded-xl bg-gray-50 text-sm overflow-hidden"
  >
    <!-- Header (Clickable) -->
    <div
      class="flex justify-between items-center p-4 cursor-pointer"
      (click)="toggleBankDetails()"
    >
      <h3 class="font-semibold text-gray-800">
        Bank Transfer Details & Instructions
      </h3>

      <!-- Arrow Icon -->
      <span
        [class.rotate-180]="showBankDetails"
        class="transition-transform duration-300"
      >
        ▼
      </span>
    </div>

    <!-- Expand Content -->
    <div *ngIf="showBankDetails" class="px-4 pb-4 space-y-3">
      <div class="space-y-1 text-gray-700">
        <p><span class="font-medium">Bank:</span> Commercial Bank</p>
        <p>
          <span class="font-medium">Account Name:</span> ONE ZERO CODE (PVT)LTD
        </p>
        <p><span class="font-medium">Account Number:</span> 1001031482</p>
        <p><span class="font-medium">Branch:</span> 162 - THAMBUTTEGAMA</p>
      </div>

      <div class="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p class="font-medium text-gray-800">Instructions</p>
        <p class="text-gray-600 mt-1">
          After placing the order using
          <span class="font-medium">Bank Transfer</span>, please complete the
          payment and send the payment slip to our
          <span class="font-medium">WhatsApp</span>. Your order will be
          confirmed once verified.
          <br />
          <span class="font-medium">WhatsApp: </span>
          <a
            class="text-green-600 font-medium underline"
            href="https://wa.me/94788670865"
            target="_blank"
            >+94 78 867 0865</a
          >
        </p>
      </div>
    </div>
  </div>
  <!-- Cancel Order Button -->
  <div
    class="mt-4 flex justify-end"
    *ngIf="order.status === 'Pending' || order.status === 'Cancelled'"
  >
    <button
      (click)="cancelOrder(order.id)"
      [disabled]="orderCancelLoading || order.status === 'Cancelled'"
      [ngClass]="
        order.status == 'Cancelled'
          ? 'bg-gray-500'
          : 'bg-red-500 hover:bg-red-600'
      "
      class="w-32 flex justify-center cursor-pointer text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
    >
      @if (orderCancelLoading) {
        <app-items-loading size="w-5 h-5" color="#ffffff"></app-items-loading>
      } @else {
        {{ order.status === "Cancelled" ? "Orde Cancelled" : "Cancel Order" }}
      }
    </button>
  </div>

  <!-- Status Progress Bar -->
  <div class="status-bar mt-4 flex items-center justify-between">
    <ng-container *ngFor="let step of statusSteps; let i = index">
      <div class="flex flex-col items-center text-center w-1/4 relative">
        <div
          class="status-icon mb-1 z-10 flex items-center justify-center rounded-full w-8 h-8 border-2"
          [ngClass]="{
            'bg-[var(--primary)] text-white border-[var(--primary)]':
              i <= currentStatusIndex,
            'border-gray-300 text-gray-400': i > currentStatusIndex,
          }"
        >
          <fa-icon [icon]="step.icon" class="text-xl"></fa-icon>
        </div>
        <div
          class="text-xs font-medium"
          [ngClass]="{
            'text-[var(--primary)]': i <= currentStatusIndex,
            'text-gray-400': i > currentStatusIndex,
          }"
        >
          {{ step.label }}
        </div>

        <div
          *ngIf="i < statusSteps.length - 1"
          class="connector absolute top-4 right-0 w-full h-1"
          [ngClass]="{
            'bg-[var(--primary)]': i < currentStatusIndex,
            'bg-gray-300': i >= currentStatusIndex,
          }"
          style="left: 50%; right: -50%"
        ></div>
      </div>
    </ng-container>
  </div>
</div>
